module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['progress-bar', 'progress-bar-' + _vm.type, {
      active: _vm.animated,
      'progress-bar-striped': _vm.striped
    }],
    style: ({
      width: _vm.nowNum + '%'
    }),
    domProps: {
      "textContent": _vm._s(_vm.labelBool ? _vm.nowNum + '%' : null)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c05aafea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-strap/src/Progressbar.vue
// module id = 566
// module chunks = 1